import React from 'react';

function ParticipantOiTable({ data, isLoading = false }) {
  // Helper function to format large numbers
  const formatNumber = (num) => {
    if (num === null || num === undefined) return '-';
    const absNum = Math.abs(num);
    if (absNum >= 100000) {
      return `${(num / 100000).toFixed(2)}L`;
    }
    return num.toLocaleString('en-IN');
  };

  // Helper function to get sentiment class
  const getSentimentClass = (sentiment) => {
    if (!sentiment) return 'sentiment-indecisive';
    if (sentiment.includes('Bullish')) return 'sentiment-bullish';
    if (sentiment.includes('Bearish')) return 'sentiment-bearish';
    return 'sentiment-indecisive';
  };

  // Enhanced data validation with logging
  const hasData = data && Array.isArray(data) && data.length > 0;
  
  // Debug logging
  React.useEffect(() => {
    if (data !== undefined && data !== null) {
      console.log('📊 ParticipantOiTable received data:', {
        isArray: Array.isArray(data),
        length: Array.isArray(data) ? data.length : 'N/A',
        hasData,
        sample: Array.isArray(data) && data.length > 0 ? data[0] : null
      });
    } else {
      console.log('⚠️ ParticipantOiTable: data is', data);
    }
  }, [data, hasData]);

  return (
    <div className="participant-table-container">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">Participant Activity (Derivatives)</h4>
      {isLoading && !hasData ? (
        <div className="text-center py-4 text-gray-500 text-sm">
          <div className="animate-pulse">Loading participant data...</div>
        </div>
      ) : !hasData ? (
        <div className="text-center py-4 text-gray-500 text-sm">
          <p>Participant data will appear here once available.</p>
          {data === null && <p className="text-xs mt-1">(Data is null - may not be fetched yet)</p>}
          {data === undefined && <p className="text-xs mt-1">(Data is undefined - not included in response)</p>}
          {Array.isArray(data) && data.length === 0 && <p className="text-xs mt-1">(Empty array - no records found)</p>}
        </div>
      ) : (
        <table className="participant-table">
          <thead>
            <tr>
              <th>Participant</th>
              <th>Segment</th>
              <th colSpan="2">Sentiment</th>
              <th>Net OI</th>
              <th>Change</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>{row.participant}</td>
                <td>{row.segment}</td>
                <td colSpan="2">
                  <span className={`sentiment-badge ${getSentimentClass(row.sentiment)}`}>
                    {row.sentiment || 'Indecisive'}
                  </span>
                </td>
                <td>{formatNumber(row.net_oi)}</td>
                <td>{formatNumber(row.change)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ParticipantOiTable;

